/* bk-clone-listicle.js
   Reproduit les deux seules interactions de la page clonee :
   - les accordeons  [data-replo-collapsible]
   - les carrousels  [data-replo-carousel]  (mode glissement ou fondu)
   Le bundle du constructeur d'origine n'est pas utilisable ici ; ce fichier
   pilote le markup existant sans le modifier. */
(function () {
  'use strict';

  var ANIM = 400; // ms, transition des carrousels
  var COLLAPSE = 200; // ms, doit correspondre aux keyframes slideDown/slideUp du CSS

  /* ---------------------------------------------------------------- accordeons */

  function initCollapsible(wrap) {
    var trigger = wrap.querySelector('[aria-controls]');
    var panel = wrap.querySelector('.replo-animated');
    if (!trigger || !panel) return;

    var timer = null;

    function state(open) {
      panel.style.setProperty('--radix-collapsible-content-height', panel.scrollHeight + 'px');
      wrap.setAttribute('data-state', open ? 'open' : 'closed');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (timer) { clearTimeout(timer); timer = null; }
      if (open) {
        panel.hidden = false;
        panel.setAttribute('data-state', 'open');
      } else {
        panel.setAttribute('data-state', 'closed');
        timer = setTimeout(function () { panel.hidden = true; }, COLLAPSE);
      }
    }

    function toggle(e) {
      if (e) e.preventDefault();
      state(trigger.getAttribute('aria-expanded') !== 'true');
    }

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') toggle(e);
    });

    // etat initial : ferme, comme au rendu serveur
    panel.hidden = true;
    panel.setAttribute('data-state', 'closed');
    wrap.setAttribute('data-state', 'closed');
    trigger.setAttribute('aria-expanded', 'false');
  }

  /* ---------------------------------------------------------------- carrousels */

  function initCarousel(root) {
    var track = root.querySelector('[data-replo-part="slide-track"]');
    if (!track) return;

    var all = [];
    for (var i = 0; i < track.children.length; i++) {
      if (track.children[i].getAttribute('data-replo-part') === 'slide') all.push(track.children[i]);
    }
    if (!all.length) return;

    // le rendu serveur duplique des diapos pour l'effet de boucle : on ne garde
    // qu'une occurrence par diapo source
    var seen = Object.create(null);
    var slides = [];
    all.forEach(function (s) {
      var key = s.getAttribute('data-slide-source-index');
      if (key !== null && key in seen) { s.parentNode.removeChild(s); return; }
      if (key !== null) seen[key] = true;
      slides.push(s);
    });

    var fade = slides.some(function (s) {
      return /(^|;)\s*opacity\s*:/.test(s.getAttribute('style') || '');
    });

    var buttons = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-replo-part="nav-button"]'), function (b) {
      if (b.closest('[data-replo-carousel]') === root) buttons.push(b);
    });

    var live = root.querySelector('[aria-live]');
    var index = 0;
    var total = slides.length;

    if (total < 2) {
      buttons.forEach(function (b) { b.style.display = 'none'; });
    }

    function offset(n) {
      return 'calc(-' + n + ' * (100% + var(--replo-gap, 0px)))';
    }

    function render(animate) {
      var dur = animate ? ANIM + 'ms' : '0ms';

      if (fade) {
        track.style.transform = 'translate3d(0, 0, 0)';
        track.style.transitionProperty = 'none';
        slides.forEach(function (s, n) {
          s.style.position = 'relative';
          s.style.left = offset(n);
          s.style.zIndex = n === index ? '1' : '-1';
          s.style.opacity = n === index ? '1' : '0';
          s.style.transitionProperty = 'opacity';
          s.style.transitionDuration = dur;
          s.style.transitionTimingFunction = 'ease';
          s.style.pointerEvents = n === index ? '' : 'none';
        });
      } else {
        track.style.transitionProperty = 'transform';
        track.style.transitionDuration = dur;
        track.style.transitionTimingFunction = 'ease';
        track.style.transform = 'translate3d(' + offset(index) + ', 0, 0)';
      }

      slides.forEach(function (s, n) {
        var active = n === index;
        if (active) { s.setAttribute('data-is-active', 'true'); s.removeAttribute('aria-hidden'); }
        else { s.removeAttribute('data-is-active'); s.setAttribute('aria-hidden', 'true'); }
      });

      if (live) live.textContent = 'Slide ' + (index + 1) + ' of ' + total;
    }

    function go(delta) {
      index = (index + delta + total) % total;
      render(true);
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        go(b.getAttribute('data-direction') === 'previous' ? -1 : 1);
      });
    });

    // glissement au doigt
    var x0 = null, y0 = null;
    track.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    render(false);
    window.addEventListener('resize', function () { render(false); });
  }

  /* ---------------------------------------------------------------- amorcage */

  function init() {
    var scope = document.querySelector('[data-bk-clone-listicle]') || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-replo-collapsible]'), initCollapsible);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-replo-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
